import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {findDOMNode} from 'react-dom'
import {connect} from 'react-redux'
import {WINDOW} from '../constants/environment'
import {
  DEFAULT_THRESHOLD_NORMAL,
  DEFAULT_THRESHOLD_WIDE,
} from '../constants/layout'
import {selectors} from '../store/actions/environment'
import {
  noop,
  isFunction,
  mapValues,
  isFinite,
  pick,
  constant,
  shallowEq,
  omit,
  getComponentDisplayName,
  compareArrays,
} from '../utils'

const resolveThresholds = (thresholds, win, rect) =>
  mapValues((thresh) => {
    if (isFunction(thresh)) return Boolean(thresh(win, rect))
    if (Array.isArray(thresh)) {
      return thresh.map(breakPoint => (isFinite(breakPoint) ? win.innerWidth < breakPoint: false))
    }
    return isFinite(thresh) ? win.innerWidth < thresh: false
  }, thresholds)

export default ({
                  thresholds = {
                    compact: ({innerWidth}) => innerWidth < DEFAULT_THRESHOLD_NORMAL,
                    wide: ({innerWidth}) => innerWidth >= DEFAULT_THRESHOLD_WIDE,
                  },
                  defaultThresholds = {
                    compact: true,
                    wide: false,
                  },
                  onChange = noop,
                  expose = 'thresholds',
                } = {}) => (Wrapped) => {
  class DetectThresholds extends PureComponent {
    constructor(props) {
      super(props)
      
      const initState = {
        ...mapValues(constant(false), thresholds),
        ...pick(Object.keys(thresholds), defaultThresholds || {}),
      }
      
      this.state = {[expose]: initState}
    }
    
    stateFromProps(props) {
      const next = resolveThresholds(
        thresholds,
        props._WINDOW_SIZE_,
        this.domNode ? this.domNode.getBoundingClientRect(): {},
      )
      
      if (
        !shallowEq(this.state[expose], next) ||
        !compareArrays(Object.values(this.state[expose]), Object.values(next))
      ) {
        this.setState({[expose]: next})
        onChange(next)
      }
    }
    
    componentDidMount() {
      if (WINDOW) this.domNode = findDOMNode(this) // TODO: some other way
      this.stateFromProps(this.props)
    }
    
    componentWillReceiveProps(nextProps) {
      this.stateFromProps(nextProps)
    }
    
    render() {
      const innerProps = {
        ...omit(['_WINDOW_SIZE_'], this.props),
        [expose]: this.state[expose],
      }
      return <Wrapped {...innerProps} />
    }
  }
  
  DetectThresholds.propTypes = {
    _WINDOW_SIZE_: PropTypes.shape({
      innerWidth: PropTypes.number,
      innerHeight: PropTypes.number,
    }),
  }
  
  DetectThresholds.displayName = `DetectThresholds(${getComponentDisplayName(Wrapped)})`
  
  const mapStateToProps = state => ({
    _WINDOW_SIZE_: selectors.getWindowSize(state),
  })
  
  return connect(mapStateToProps)(DetectThresholds)
}



// WEBPACK FOOTER //
// ./src/higher-order-components/detect-thresholds.jsx